export const paths = {
  sessions: '/iphone/sessions',
  users: '/iphone/users',
  info: '/sessions/info',
};
